<app-card>
  <form [formGroup]="searchForm">
    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.dateofwork' | translate }}</label>
          <input appInputDate [defaultDate]="false" formControlName="dayOfWork">
        </app-input-group>
      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.meteringpointid' | translate }}</label>
          <input appInput type="text" formControlName="meteringPointId"
                 [placeholder]="'dashboard.timeseries.missing.meteringpointid' | translate">
        </app-input-group>
      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.meteringpointtype' | translate }}</label>
          <select appSelect [collection]="meteringPointType" formControlName="meteringPointType">
          </select>
        </app-input-group>
      </div>
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.meteringpointsubtype' | translate }}</label>
          <select appSelect [collection]="meteringPointSubType" formControlName="meteringPointSubType">
          </select>
        </app-input-group>
      </div>
    </div>

    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.streetname' | translate }}</label>
          <input type="text" appInput formControlName="streetName"
                 [placeholder]="'dashboard.timeseries.missing.streetname' | translate">
        </app-input-group>
      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.housenumber' | translate }}</label>
          <input type="text" appInput formControlName="buildingNumber"
                 [placeholder]="'dashboard.timeseries.missing.housenumber' | translate">
        </app-input-group>
      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.postalcode' | translate }}</label>
          <input type="text" appInput formControlName="postalCode"
                 [placeholder]="'dashboard.timeseries.missing.postalcode' | translate">
        </app-input-group>

      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.settlementmethod' | translate }}</label>
          <select appSelect [collection]="settlementMethod" formControlName="settlementMethod">
          </select>
        </app-input-group>
      </div>
    </div>

    <div class="flex gap-4">
      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.meterreadingoccurrence' | translate }}</label>
          <select appSelect [collection]="meterReadingOccurrence" formControlName="meterReadingOccurrence">
          </select>
        </app-input-group>
      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.estimationgroup' | translate }}</label>
          <input type="text" appInput formControlName="estimationGroup"
                 [placeholder]="'dashboard.timeseries.missing.estimationgroup' | translate">
        </app-input-group>
      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.missingdatastatus' | translate }}</label>
          <select appSelect [collection]="missingDataStatus" formControlName="missingDataStatus">
          </select>
        </app-input-group>
      </div>

      <div class="w-1/4">
        <app-input-group>
          <label appLabel>{{ 'dashboard.timeseries.missing.errormessage' | translate }}</label>
          <input appInput type="text" formControlName="errorMessage"
                 [placeholder]="'dashboard.timeseries.missing.errormessage' | translate">
        </app-input-group>
      </div>
    </div>
    <div class="flex gap-2">
      <button appButton (click)="performSearch()">
        {{ 'common.search' | translate }}
      </button>

      <button appButton (click)="resetForm()" type="tertiary">
        {{ 'common.reset' | translate }}
      </button>
    </div>
  </form>
</app-card>

<div class="flex justify-end mb-2">
  <div class="text-sm text-gray-600 flex items-center gap-2">
    <span>
      {{ 'dashboard.timeseries.missing.showHandled' | translate }}
    </span>

    <form [formGroup]="toggleForm">
      <app-toggle formControlName="showManuallyHandled"></app-toggle>
    </form>
  </div>
</div>

<app-table
  #table
  [config]="missingMeteredDataTableConfig"
  [(selectedElements)]="selectedElements">
</app-table>
